{
  "title": "Credentials",
  "subtitle": "Auth tokens for HTTP requests — attached automatically when the URL matches the host in the pattern.",
  "loading": "Loading…",
  "extension_empty": "No extension credentials yet.",
  "security_note": "Tokens NEVER appear in the LLM context or tool results. They are only injected server-side as headers when fetch_url targets a matching URL.",
  "new": "New credential",
  "new_title": "New credential",
  "edit_title": "Edit credential: {{name}}",
  "delete_confirm": "Really delete credential \"{{name}}\"?",
  "empty": "No credentials yet.",
  "name": "Name",
  "name_invalid": "Invalid — only a-z, 0-9, _ and -, max 50 chars.",
  "type": "Type",
  "type_bearer": "Bearer token",
  "type_basic": "Basic auth (user:pass)",
  "type_cookie": "Cookie",
  "type_header": "Custom header",
  "type_query": "Query parameter",
  "type_ssh_key": "SSH key",
  "value": "Value",
  "value_hint_bearer": "E.g. an API token. Sent as 'Authorization: Bearer <value>'.",
  "value_hint_basic": "Format 'user:password'. Sent base64-encoded as 'Authorization: Basic ...'.",
  "value_hint_cookie": "E.g. 'session=abc123'. Sent as 'Cookie: <value>'.",
  "value_hint_header": "Value of the custom header.",
  "value_hint_query": "Value of the query param.",
  "header_name": "Header name",
  "header_name_required": "Header name is required.",
  "query_param": "Query param name",
  "query_param_required": "Query param name is required.",
  "url_pattern": "URL pattern",
  "url_pattern_hint": "Pattern with a concrete host, e.g. 'https://api.example.com/*' or 'https://*.example.com/*'. Only then is the secret attached. fetch_url never uses '*' (all URLs).",
  "description": "Description",
  "ssh_private_key": "Private key (PEM)",
  "ssh_private_key_hint": "OpenSSH or PEM format. Stored encrypted, never passed to the agent.",
  "ssh_host": "Hostname / IP",
  "ssh_host_hint": "Host the agent should SSH into.",
  "ssh_host_required": "Hostname / IP is required.",
  "ssh_host_invalid": "Only letters, digits, dots and hyphens allowed (max 253 chars).",
  "ssh_user": "SSH username",
  "ssh_user_required": "SSH username is required.",
  "ssh_user_invalid": "Only letters, digits, dots, underscores and hyphens allowed (max 32 chars).",
  "url_pattern_wildcard_warning": "This pattern names no concrete host, so fetch_url never attaches this secret — not even when an agent asks for it by name. Enter the host it is meant for.",
  "not_host_bound": "No host — fetch_url never attaches it",
  "unbound_banner_one": "{{count}} secret without a concrete host is never attached by fetch_url. Open it and enter the host it is meant for.",
  "unbound_banner_other": "{{count}} secrets without a concrete host are never attached by fetch_url. Open them and enter the host each is meant for."
}
